import React, { Component } from 'react'
import BundleScanner from '../components/BundleScanner'
import { InputTextRef } from '../components/InputText'

interface PackTraceCreateCaseProps {
  scan: string
  inputRef: InputTextRef
  onScan: (scan: string) => void
  onCaseScanError: boolean
  onCaseScanErrorCallback: () => void

}

export default class PackTraceCreateCase
  extends Component<PackTraceCreateCaseProps> {
  get status () {
    return this.props.scan
      ? 'selected'
      : 'available'
  }

  render () {
    return (
      <BundleScanner
        className="m-3"
        size="double"
        status={this.status}
        label="Case"
        inputRef={this.props.inputRef}
        onCaseScan={this.props.onScan} 
        onScanError={this.props.onCaseScanError}
        onScanErrorCallback={this.props.onCaseScanErrorCallback}/>
    )
  }
}
